import {platformSvg as Icon__small__platformSvg} from '../Icon__small/Icon__small--platform.js'
import {platformSvg as Icon__xsmall__platformSvg} from '../Icon__xsmall/Icon__xsmall--platform.js'

export var platform = {
  name: 'platform',
  category: 'icon',
  colorable: true,
  svg: Icon__small__platformSvg,
  alt: {
    Icon__small: Icon__small__platformSvg,
    Icon__xsmall: Icon__xsmall__platformSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
